import { Salutation, User } from '../../../@types/types'
import { getSalutation } from '../../../services/conversion/conversionServices'

export const userToApp = (userLiteral: string): User => {
  const user = JSON.parse(userLiteral)
  const contact = user.contact
  return {
    contact: {
      email: contact?.email ? contact.email : undefined,
      firstName: contact?.firstName ? contact.firstName : undefined,
      lastName: contact?.lastName ? contact.lastName : undefined,
      phoneNumber: contact?.phoneNumber ? contact.phoneNumber : undefined,
      salutationType: contact?.salutationType ? getSalutation(contact.salutationType) : Salutation.NO_SALUTATION,
    },
    contingentCustomer: user.contingentCustomer,
    isProfessional: user.isProfessional ?? false,
    ssoId: user.ssoId,
  }
}
